// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609250626/js/" + chunkId + "." + {"44":"3e4fba7a","225":"e60ee908","481":"5fc50c49","486":"563bf751","770":"57564cfe"}[chunkId] + ".0.6236636166832463.chunk.js";
};